import { createReducer } from '@reduxjs/toolkit';
import * as userActions from '../actions/user.action';

const initialState = {
  userInfo: null
};

const setUserInfo = (state, { payload }) => {
  state.userInfo = payload;
};

export default createReducer(initialState, builder => {
  builder
    .addCase(userActions.setUserInfo, setUserInfo);
});
